// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MBzsT","container":"Footer_container__SsblI","box1":"Footer_box1__T-U8b","box2":"Footer_box2__ePS9n","info":"Footer_info__-A5Ta","icon":"Footer_icon__xoyO9"};